// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uRXTjXZkM4zTQQax_shB {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 5rem 1rem;
  min-height: 100vh;
  font-size: 0.5rem;
}
@media (min-width: 900px) {
  .uRXTjXZkM4zTQQax_shB {
    font-size: 1rem;
    flex-direction: row;
    align-items: flex-start;
  }
  .uRXTjXZkM4zTQQax_shB div, .uRXTjXZkM4zTQQax_shB h1 {
    margin: 0 3rem;
  }
}
.uRXTjXZkM4zTQQax_shB {
  color: hsl(249, 68%, 15%);
}
.uRXTjXZkM4zTQQax_shB h1 {
  font-size: 4.4em;
}
.uRXTjXZkM4zTQQax_shB h1 .fU3vwHExhFGIErdI2_cj {
  font-size: 1em;
  text-decoration: underline hsl(232, 100%, 64%);
  text-underline-offset: 0.2em;
}
.uRXTjXZkM4zTQQax_shB .VuNg0sSGZAyZBhIM2ta4 div {
  font-size: 1rem;
}
@media (min-width: 900px) {
  .uRXTjXZkM4zTQQax_shB .VuNg0sSGZAyZBhIM2ta4 div {
    font-size: 1.5rem;
  }
}
.uRXTjXZkM4zTQQax_shB .VuNg0sSGZAyZBhIM2ta4 div h3 {
  font-size: 1.5em;
}
.uRXTjXZkM4zTQQax_shB .VuNg0sSGZAyZBhIM2ta4 div p {
  font-size: 1em;
}`, "",{"version":3,"sources":["webpack://./src/section/index.module.scss","webpack://./src/scss/media.scss","webpack://./src/scss/colors.scss"],"names":[],"mappings":"AAGA;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;AAFD;ACPC;EDED;IASE,eAAA;IACA,mBAAA;IACA,uBAAA;EAAA;EACA;IACC,cAAA;EACD;AACF;AAfA;EAgBC,yBEnBS;AFqBV;AADC;EACC,gBAAA;AAGF;AAFE;EACC,cAAA;EACA,8CAAA;EACA,4BAAA;AAIH;AAAE;EACC,eAAA;AAEH;AC/BC;ED4BC;IAGE,iBAAA;EAIF;AACF;AAHG;EACC,gBAAA;AAKJ;AAHG;EACC,cAAA;AAKJ","sourcesContent":["@use \"../scss/colors.scss\";\n@use \"../scss/media.scss\" as *;\n\n.container {\t\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tjustify-content: center;\n\tpadding: 5rem 1rem;\n\tmin-height: 100vh;\n\tfont-size: .5rem;\n\t@include on-desktop {\n\t\tfont-size: 1rem;\n\t\tflex-direction: row;\n\t\talign-items: flex-start;\n\t\tdiv, h1 {\n\t\t\tmargin: 0 3rem;\n\t\t}\n\t}\n\tcolor: colors.$primary;\n\th1 {\n\t\tfont-size: 4.4em;\n\t\t.ul {\n\t\t\tfont-size: 1em;\n\t\t\ttext-decoration: underline colors.$secondary;\n\t\t\ttext-underline-offset: .2em;\n\t\t}\n\t}\n\t.reasons {\n\t\tdiv {\n\t\t\tfont-size: 1rem;\n\t\t\t@include on-desktop {\n\t\t\t\tfont-size: 1.5rem;\n\t\t\t}\n\t\t\th3 {\n\t\t\t\tfont-size: 1.5em;\n\t\t\t}\n\t\t\tp {\n\t\t\t\tfont-size: 1em;\n\t\t\t}\n\t\t}\n\t}\n}\n","@mixin on-desktop {\n\t@media (min-width: 900px) {\n\t\t@content;\n\t}\n}\n","$primary: hsl(249, 68%, 15%);\n$secondary: hsl(232, 100%, 64%);\n$ternary: hsl(221, 66%, 94%);\n\n$dark: hsl(250, 73%, 12%);\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `uRXTjXZkM4zTQQax_shB`,
	"ul": `fU3vwHExhFGIErdI2_cj`,
	"reasons": `VuNg0sSGZAyZBhIM2ta4`
};
export default ___CSS_LOADER_EXPORT___;
